const getValue = (cname) => {
    cname = `${cname}=`;
    const ca = document.cookie.split(';');
    let i = 0;
    for (i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(cname) === 0) {
            return c.substring(cname.length, c.length);
        }
    }
    return false;
};

const buildScope = (params) => {
    let domainStr = '';
    // TUICIBE-563: because local development runs under http://tuic-ibe-v/
    const hasDot = window.location.hostname.indexOf('.') !== -1;

    if (hasDot && !(params && params.hostOnly)) {
        domainStr = `; domain=.${window.location.hostname.split('.').slice(-2).join('.')}`;
    }

    return {
        domainStr,
        path: (params && params.path) || '/',
        hasDot
    };
};

const setValue = (cname, value, params) => {
    const {domainStr, path, hasDot} = buildScope(params);

    cname = `${cname}=${value}${domainStr}; Path=${path}`;
    if (params && params.expires) {
        const expires = new Date();
        expires.setMilliseconds(expires.getMilliseconds() + params.expires * 864e+5);
        params.expires = expires.toUTCString();
        cname = `${cname};expires=${params.expires}`;
    }
    if (params && params.sameSite) {
        cname = `${cname};SameSite=${params.sameSite}`;
    }
    if (params && params.secure && hasDot) {
        cname = `${cname};secure`;
    }

    document.cookie = cname;
    return true;
};

const deleteCookie = (cname, params) => {
    const {domainStr, path} = buildScope(params);

    document.cookie = `${cname}=${domainStr}; Path=${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export default {
    getValue,
    setValue,
    deleteCookie
};
